// import merge from 'lodash/merge';

export const uflContainerMd = {
  maxW: 'ufl.container.md',
  mx: 'auto',
};

export const lightContrastBox = {
  backgroundColor: 'white',
  // https://github.com/chakra-ui/chakra-ui/issues/2231
  '.chakra-ui-dark &': {
    backgroundColor: 'tmtGray80',
  },
};

export const contrastBox = {
  backgroundColor: 'white',
  // https://github.com/chakra-ui/chakra-ui/issues/2231
  '.chakra-ui-dark &': {
    backgroundColor: 'black',
  },
};

export const requiredText = {
  fontSize: { base: 'xs', md: 'sm' },
  fontStyle: 'oblique',
  textAlign: 'center',
  p: {
    color: 'gray.800',
    '.chakra-ui-dark &': {
      color: 'gray.200',
    },
  },
};

export const errorText = {
  bg: 'red.100',
  py: 2,
  px: 3,
  border: '1px',
  borderColor: 'errorColor',
  fontSize: { base: 'xs', md: 'sm' },
  position: 'relative',
  top: -2,
  p: {
    color: 'black',
  },
  '.chakra-ui-dark &': {
    bg: 'red:900',
    color: 'white',
    p: {
      color: 'white',
    },
  },
};

export const fieldWrapper = {
  maxW: 'ufl.fieldWrapperMaxWidth',
  mx: 'auto',
  mb: 6,
};

export const numberFieldWrapper = {
  maxW: '100px',
  mx: 'auto',
  mb: 6,
};

export const helperText = {
  color: 'gray.800',
  _dark: {
    color: 'gray.200',
  },
  lineHeight: 'normal',
  fontSize: 'sm',
};

export const darkTextColor = {
  color: 'headingFontColor',
  _dark: {
    color: 'darkHeadingFontColor',
  },
};

export const grayBackground = {
  bg: 'gray.200',
  _dark: {
    bg: 'gray.700',
  },
};

export const keyboard = {
  border: '1px',
  display: 'inline-block',
  fontSize: 'sm',
  lineHeight: '1',
  minW: '2em',
  px: 2,
  py: 1,
  textAlign: 'center',
};

export const modalImageContainer = {
  ...grayBackground,
  mt: { base: -5, md: -8 },
  ml: { base: -5, md: -8 },
  mr: { base: -5, md: -8 },
};

export const formActions = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  justifyContent: 'center',
  alignItems: 'center',
};

export const formPrimaryActions = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 2,
  justifyContent: 'center',
  alignItems: 'center',
  w: '100%',
  maxW: 'lg',
  '> *': {
    flexGrow: 2,
    maxW: '320px',
  },
};

export const requiredIndicator = {
  color: 'red.400',
  ml: 1,
};

// export const borderBox = {
//   border: '1px solid',
//   borderColor: 'borderColor',
//   // https://github.com/chakra-ui/chakra-ui/issues/2231
//   '.chakra-ui-dark &': {
//     borderColor: 'darkBorderColor',
//   },
// };

// // Merge mutates the first argument! https://lodash.com/docs/4.17.15#merge
// export const contrastBorderBox = merge({ ...contrastBox }, borderBox);
